var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.6602L10 13.6602C10.804 13.6602 12 13.1275 12 11.6602L12 2.32682C12 0.859489 10.804 0.326822 10 0.326822L0 0.326822V1.66016L9.992 1.66016C10.3 1.66816 10.6667 1.79016 10.6667 2.32682C10.6667 2.39416 10.6607 2.45416 10.6507 2.50882C10.576 2.89216 10.262 2.98682 9.99267 2.99349L0.666666 2.99349C0.654666 2.99349 0.646 2.99949 0.634 3.00016H0L0 12.3268C0 13.0622 0.598 13.6602 1.33333 13.6602ZM1.33333 4.32682L10.6667 4.32682L10.6667 11.6602C10.6667 12.1975 10.3 12.3188 10 12.3268H5.33333L5.33333 7.66016L4 8.32682L2.66667 7.66016V12.3268H1.33333L1.33333 4.32682Z",
    fill: "#6F7781"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepoIcon);
export default __webpack_public_path__ + "static/media/repo-icon.62891d75c1ed7f373ad4691b4e22bde0.svg";
export { ForwardRef as ReactComponent };